<h2 mat-dialog-title class="dialog-title">{{isEdit ? 'Kunde bearbeiten' : 'Neuer Kunde'}}</h2>

<mat-dialog-content class="customer-dialog-content">
  <div class="form-grid">
    <div class="form-section">
      <div class="section-label">Stammdaten</div>

      <mat-form-field *ngIf="canChooseCustomerType" appearance="outline" class="full-width">
        <mat-label>Kundenart</mat-label>
        <mat-select [(ngModel)]="customer.type">
          <mat-option value="Normal">Normal (Wartung &amp; Einsätze)</mat-option>
          <mat-option value="Stammkunde">Stammkunde (eigene Personen-Einsatzplanung)</mat-option>
        </mat-select>
        <mat-icon matPrefix>badge</mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Firmenname</mat-label>
        <input matInput [(ngModel)]="customer.name" required placeholder="z.B. Musterfirma GmbH">
        <mat-icon matPrefix>business</mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Adresse</mat-label>
        <input matInput [(ngModel)]="customer.address" placeholder="Straße, PLZ Ort">
        <mat-icon matPrefix>location_on</mat-icon>
      </mat-form-field>

      <div class="section-label subtle">Ansprechpartner</div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Name</mat-label>
        <input matInput [(ngModel)]="customer.contactPersonName" placeholder="Vor- und Nachname">
        <mat-icon matPrefix>person</mat-icon>
      </mat-form-field>

      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Telefon</mat-label>
          <input matInput [(ngModel)]="customer.contactPersonPhone" placeholder="+43 ...">
          <mat-icon matPrefix>phone</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>E-Mail</mat-label>
          <input matInput type="email" [(ngModel)]="customer.contactPersonEmail" placeholder="email@firma.at">
          <mat-icon matPrefix>email</mat-icon>
        </mat-form-field>
      </div>

      <div class="section-header contact-header">
        <div>
          <div class="section-label subtle">Weitere Kontaktpersonen</div>
          <span>Eine Person kann mehrere Rollen haben.</span>
        </div>
        <button mat-stroked-button type="button" (click)="addContactPerson()">
          <mat-icon>person_add</mat-icon>
          Person hinzufügen
        </button>
      </div>

      <div class="contact-list" *ngIf="contactPersons.length > 0">
        <div class="contact-card" *ngFor="let contact of contactPersons; let i = index">
          <div class="contact-card-head">
            <strong>Person {{i + 1}}</strong>
            <button mat-icon-button color="warn" type="button" (click)="removeContactPerson(i)" matTooltip="Person entfernen">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline">
              <mat-label>Name</mat-label>
              <input matInput [(ngModel)]="contact.fullName">
              <mat-icon matPrefix>person</mat-icon>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>E-Mail</mat-label>
              <input matInput type="email" [(ngModel)]="contact.email">
              <mat-icon matPrefix>email</mat-icon>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline">
              <mat-label>Telefon</mat-label>
              <input matInput [(ngModel)]="contact.phone">
              <mat-icon matPrefix>phone</mat-icon>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Adresse optional</mat-label>
              <input matInput [(ngModel)]="contact.address">
              <mat-icon matPrefix>location_on</mat-icon>
            </mat-form-field>
          </div>

          <div class="role-grid">
            <mat-checkbox [(ngModel)]="contact.isInvoiceRecipient">Rechnungsempfänger</mat-checkbox>
            <mat-checkbox [(ngModel)]="contact.isShippingRecipient">Versand</mat-checkbox>
            <mat-checkbox [(ngModel)]="contact.isProjectManager">Projektleiter</mat-checkbox>
            <mat-checkbox [(ngModel)]="contact.isCommercialContact">Kaufmännisch</mat-checkbox>
            <mat-checkbox [(ngModel)]="contact.isTechnicalContact">Technisch</mat-checkbox>
          </div>

          <div class="contact-card-actions">
            <button mat-button type="button" (click)="applyContactToInvoice(contact)">Für Rechnung</button>
            <button mat-button type="button" (click)="applyContactToShipping(contact)">Für Versand</button>
            <button mat-button type="button" (click)="applyContactToProject(contact)">Als Projektleiter</button>
          </div>
        </div>
      </div>
    </div>

    <div class="form-section">
      <div class="section-header">
        <div>
          <div class="section-label">Rechnungsdaten</div>
          <span>Diese Werte werden auf der Rechnung verwendet.</span>
        </div>
        <button mat-stroked-button type="button" (click)="copyBaseAddressToInvoice()">
          <mat-icon>content_copy</mat-icon>
          Stammdaten übernehmen
        </button>
      </div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Rechnungsempfänger</mat-label>
        <input matInput [(ngModel)]="customer.invoiceName" placeholder="z.B. EBG GmbH">
        <mat-icon matPrefix>receipt_long</mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Rechnungsadresse</mat-label>
        <textarea matInput rows="3" [(ngModel)]="customer.invoiceAddress" placeholder="Straße&#10;PLZ Ort"></textarea>
        <mat-icon matPrefix>location_on</mat-icon>
      </mat-form-field>

      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Kundennummer</mat-label>
          <input matInput [(ngModel)]="customer.customerNumber">
          <mat-icon matPrefix>tag</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>UID-Kunde</mat-label>
          <input matInput [(ngModel)]="customer.vatId" placeholder="ATU...">
          <mat-icon matPrefix>badge</mat-icon>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Ihre Bestellung</mat-label>
          <input matInput [(ngModel)]="customer.orderNumber">
          <mat-icon matPrefix>assignment</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Bestelldatum</mat-label>
          <input matInput type="date" [(ngModel)]="customer.orderDate">
          <mat-icon matPrefix>event</mat-icon>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Projekt-Nr.</mat-label>
          <input matInput [(ngModel)]="customer.projectNumber">
          <mat-icon matPrefix>work_outline</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Rechnungs-E-Mail</mat-label>
          <input matInput type="email" [(ngModel)]="customer.invoiceEmail">
          <mat-icon matPrefix>alternate_email</mat-icon>
        </mat-form-field>
      </div>
    </div>

    <div class="form-section">
      <div class="section-header">
        <div>
          <div class="section-label">Versand und kaufmännischer Kontakt</div>
        </div>
        <button mat-stroked-button type="button" (click)="copyInvoiceToShipping()">
          <mat-icon>content_copy</mat-icon>
          Rechnung übernehmen
        </button>
      </div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Versandempfänger</mat-label>
        <input matInput [(ngModel)]="customer.shippingName">
        <mat-icon matPrefix>local_shipping</mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Versandadresse</mat-label>
        <textarea matInput rows="3" [(ngModel)]="customer.shippingAddress"></textarea>
        <mat-icon matPrefix>markunread_mailbox</mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Projektleiter / kaufmännische Ansprechperson</mat-label>
        <input matInput [(ngModel)]="customer.projectManagerName">
        <mat-icon matPrefix>person_pin</mat-icon>
      </mat-form-field>

      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Telefon Projektleiter</mat-label>
          <input matInput [(ngModel)]="customer.projectManagerPhone">
          <mat-icon matPrefix>phone</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>E-Mail Projektleiter</mat-label>
          <input matInput type="email" [(ngModel)]="customer.projectManagerEmail">
          <mat-icon matPrefix>email</mat-icon>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Lieferbedingungen</mat-label>
          <input matInput [(ngModel)]="customer.deliveryTerms" placeholder="z.B. CPT frachtfrei">
          <mat-icon matPrefix>inventory_2</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Zahlungsbedingungen</mat-label>
          <input matInput [(ngModel)]="customer.paymentTerms" placeholder="z.B. 30 Tage netto">
          <mat-icon matPrefix>payments</mat-icon>
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Rechnungsnotiz</mat-label>
        <textarea matInput rows="2" [(ngModel)]="customer.invoiceNote"></textarea>
        <mat-icon matPrefix>notes</mat-icon>
      </mat-form-field>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-button (click)="cancel()">Abbrechen</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="!customer.name?.trim() || saving">
    <mat-spinner *ngIf="saving" diameter="18" class="btn-spinner"></mat-spinner>
    {{isEdit ? 'Speichern' : 'Anlegen'}}
  </button>
</mat-dialog-actions>
